module.exports = __webpack_public_path__ + "img/map_suite-locations_field.db14332a.jpg";